import cn from "classnames";
import Styles from "./SearchResult.module.scss";
import { Text } from "src/components/atoms/Text/Text";
import * as Eden from "src/eden/content";

interface SearchResultProps {
  results: Eden.Hit;
}

const capitalize = (value?: string): string => (value ? value.charAt(0).toUpperCase() + value.slice(1) : "");

export const SearchResult = ({ results }: SearchResultProps) => {
  const { name, season, location, staff, number_of_players } = results.result;

  const metaParts = [
    `${capitalize(season?.name)} ${season?.year ?? ""}`.trim(),
    location?.city && location?.state ? `${location.city}, ${location.state}` : location?.state,
    `${number_of_players} ${number_of_players === 1 ? "player" : "players"}`,
  ].filter(Boolean);

  const hasStaff = Array.isArray(staff) && staff.length > 0;

  return (
    <>
      <Text weight="bold" color="off-black" block={true} className={cn(Styles.name)}>
        {name}
      </Text>
      <Text className={cn(Styles.details)} color="cool-grey-dark" size="xsmall" block={true}>
        {metaParts.join(" · ")}
      </Text>
      {hasStaff && (
        <Text className={cn(Styles.details)} color="cool-grey-dark" size="xsmall" block={true}>
          <>
            <b>Staff: </b>
            {staff.join(", ")}
          </>
        </Text>
      )}
    </>
  );
};
